<template>
    <div id="services" class="overflow-hidden">
        <div class="jumbo-header position-relative">
            <h1 class="jumbo-header-text">{{ webData.servicesMain.t1 }} <span class="custom-spacing"></span> {{ webData.servicesMain.t2 }}</h1>
        </div>
        <div class="wedding-first-section">
            <div class="left-wedding-image" v-observer>
                <img src="../assets/images/katarina9.jpg" alt="Opis slike">
            </div>
            <div class="right-wedding-container" v-observer>
                <div class="content-with-border" style="margin-top:50px;margin-bottom:50px">
                    <h3 style="color:#623E2A;">{{ webData.brideText.t1 }}</h3>
                    <p style="color:#623E2A;font-weight:500;font-family:revert;">{{ webData.brideText.p1 }}</p>
                </div>
                <div class="right-image">
                    <img src="../assets/images/katarina10.jpg" alt="Opis druge slike">
                </div>
            </div>
        </div>
        <div class="wedding-second-section">
            <div class="left-wedding-image second-section-left" v-observer>
                <img src="../assets/images/katarina11.jpg" alt="Opis slike">
            </div>
            <div class="right-wedding-container second-section-right" v-observer>
                <div class="content-with-border" style="margin-top:50px;margin-bottom:50px">
                    <h3 style="color:#623E2A;">{{ webData.weddingTitle }}</h3>
                </div>
                <div class="right-image second-right-img">
                    <img src="../assets/images/katarina12.jpg" alt="Opis druge slike">
                </div>
            </div>
        </div>
        <div class="parallax-container parallax1">
            <div class="video-text-top-right-services" v-observer>
                <p class="video-text-color many-events-center" style="text-align:left; font-size:35px; color:black;">{{ webData.servicesParallax1 }}</p>
            </div>
        </div>
        <div style="padding: 20px">
            <div class="concierge-section not-reverse" v-observer>
                <div class="concierge-text-section">
                    <h3>{{ webData.imageText1.t1 }}</h3>
                    <p class="concierge-text">{{ webData.imageText1.p1 }}</p>
                    <br>
                    <h3>{{ webData.imageText1.t2 }}</h3>
                    <p class="concierge-text">{{ webData.imageText1.p2 }}</p>
                    <br>
                    <h3>{{ webData.imageText1.t3 }}</h3>
                    <p class="concierge-text">{{ webData.imageText1.p3 }}</p>
                </div>
                <div class="concierge-image-section k1"></div>
            </div>
        </div>
        <div style="background-color:rgb(232,235,233); padding: 20px">
            <div class="concierge-section" v-observer>
                <div class="concierge-image-section k2"></div>
                <div class="concierge-text-section concierge-center">
                    <h3>{{ webData.imageText2.t1 }}</h3>
                    <p class="concierge-text">{{ webData.imageText2.p1 }}</p>
                    <br>
                    <h3>{{ webData.imageText2.t2 }}</h3>
                    <p class="concierge-text">{{ webData.imageText2.p2 }}</p>
                    <br>
                    <h3>{{ webData.imageText2.t3 }}</h3>
                    <p class="concierge-text">{{ webData.imageText2.p3 }}</p>
                </div>
            </div>
        </div>
        <div class="parallax-container parallax2"></div>
        <div style="background-color:rgb(232,235,233);padding-top:20px;padding-bottom:20px">
            <div class="concierge-section not-reverse" v-observer>
                <div class="concierge-text-section concierge-text-section-resize" style="padding-left:20px">
                    <h3>{{ webData.imageText3.t1 }}</h3>
                    <p class="concierge-text">{{ webData.imageText3.p1 }}</p>
                    <br>
                    <h3>{{ webData.imageText3.t2 }}</h3>
                    <p class="concierge-text">{{ webData.imageText3.p2 }}</p>
                    <br>
                    <h3>{{ webData.imageText3.t3 }}</h3>
                    <p class="concierge-text">{{ webData.imageText3.p3 }}</p>
                </div>
                <div class="concierge-image-section k3 image-section-resize"></div>
            </div>
        </div>
        <div class="yacht-section" style="background-color:rgb(232,235,233); padding: 20px">
            <div class="concierge-section" v-observer>
                <div class="concierge-image-section k4"></div>
                <div class="concierge-text-section concierge-center">
                    <h3>{{ webData.imageText4.t1 }}</h3>
                    <p class="concierge-text">{{ webData.imageText4.p1 }}</p>
                    <br>
                    <h3>{{ webData.imageText4.t2 }}</h3>
                    <p class="concierge-text">{{ webData.imageText4.p2 }}</p>
                    <br>
                    <h3>{{ webData.imageText4.t3 }}</h3>
                    <p class="concierge-text">{{ webData.imageText4.p3 }}</p>
                </div>
            </div>
        </div>
        <div style="padding: 20px">
            <div class="concierge-section not-reverse" v-observer>
                <div class="concierge-text-section">
                    <h3>{{ webData.imageText5.t1 }}</h3>
                    <p class="concierge-text">{{ webData.imageText5.p1 }}</p>
                    <br>
                    <h3>{{ webData.imageText5.t2 }}</h3>
                    <p class="concierge-text">{{ webData.imageText5.p2 }}</p>
                    <br>
                    <h3>{{ webData.imageText5.t3 }}</h3>
                    <p class="concierge-text">{{ webData.imageText5.p1 }}</p>
                </div>
                <div class="concierge-image-section k5"></div>
            </div>
        </div>
        <div class="book-now-section">
            <!--<img src="../assets/images/katarina1.jpg" alt="Luxury Vacation" class="book-now-image">-->
            <div class="book-now-image-stancija">
                <div class="contain-scale" v-observer>
                    <div class="book-now-content-stancija" v-observer>
                        <h1 style="font-weight: lighter;font-size:41px;">{{ webData.bookTitle }}</h1>
                    </div>
                    <router-link to="/book" class="book-now-button" v-observer>{{ webData.bookNow }}</router-link>
                </div>
            </div>
        </div>
        
        <!--
        <div class="pt-5 pb-5" style="width: 100%; background-color: rgba(182, 169, 235, .6); margin: 50px 0;" v-observer>
            <div class="container">
                <div class="d-flex align-items-center flex-row justify-content-center text-center" style="padding: 12px 0;">
                    <p style="font-size: 20px; margin: 0">{{webData.p1}}</p>
                </div>
            </div>
        </div>
        <div class="pt-5 pb-5">
            <carousel :nav="false" :autoplay="true" :loop="true">
                <img v-for="img in carousel" :key="img.id" :src="img.src" :alt="img.alt">
            </carousel>
        </div>
        <div class="h3-container">
            <div id="service-one" class="module-wrapper" v-observer>
                <div class="h3-container">
                    <div class="p-5-wrapper position-relative h-overflow-768 pt-0 pb-0">
                        <div class="flex-wrapper v-overflow wrap-border right">
                            <div class="img-wrapper f-item-50 text-right left">
                                <img src="../assets/static/Concierge.jpg" alt="Concierge service">
                            </div>
                            <div class="f-item-50 text-box-right green">
                                <h4>{{webData.t2}}</h4>
                                <div class="spacer-sm"></div>
                                <p class="text-justify">{{webData.p2}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="service-two" class="module-wrapper" v-observer>
                <div class="h3-container">
                    <div class="p-5-wrapper position-relative h-overflow-768 pt-0 pb-0">
                        <div class="flex-wrapper v-overflow wrap-border left">
                            <div class="f-item-50 text-box-left green">
                                <h4>{{webData.t3}}</h4>
                                <div class="spacer-sm"></div>
                                <p class="text-justify">{{webData.p3}}</p>
                            </div>
                            <div class="img-wrapper f-item-50 text-right right">
                                <img src="../assets/static/Transfers.jpg" alt="Transfers">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="service-three" class="module-wrapper" v-observer>
                <div class="h3-container">
                    <div class="p-5-wrapper position-relative h-overflow-768 pt-0 pb-0">
                        <div class="flex-wrapper v-overflow wrap-border right">
                            <div class="img-wrapper f-item-50 text-right left">
                                <img src="../assets/static/Boat_service.jpg" alt="Boat service">
                            </div>
                            <div class="f-item-50 text-box-right green">
                                <h4>{{webData.t4}}</h4>
                                <div class="spacer-sm"></div>
                                <p class="text-justify">{{webData.p4}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="service-four" class="module-wrapper" v-observer>
                <div class="h3-container">
                    <div class="p-5-wrapper position-relative h-overflow-768 pt-0 pb-0">
                        <div class="flex-wrapper v-overflow wrap-border left">
                            <div class="f-item-50 text-box-left green">
                                <h4>{{webData.t5}}</h4>
                                <div class="spacer-sm"></div>
                                <p class="text-justify">{{webData.p5}}</p>
                            </div>
                            <div class="img-wrapper f-item-50 text-right right">
                                <img src="../assets/static/Vine_tours.jpg" alt="Vine tours">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="service-five" class="module-wrapper" v-observer>
                <div class="h3-container">
                    <div class="p-5-wrapper position-relative h-overflow-768 pt-0 pb-0">
                        <div class="flex-wrapper v-overflow wrap-border right">
                            <div class="img-wrapper f-item-50 text-right left">
                                <img src="../assets/static/Daily_cleaning_service.jpg" alt="Daily cleaning service">
                            </div>
                            <div class="f-item-50 text-box-right green">
                                <h4>{{webData.t6}}</h4>
                                <div class="spacer-sm"></div>
                                <p class="text-justify">{{webData.p6}}<br>{{webData.priorNotice}}}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="module-info" class="module-wrapper" v-observer>
                <div class="p-5-wrapper">
                    <div class="flex-wrapper align-items-stretch text-left">
                        <div class="col-sm-4">
                            <div class="info-img text-center mb-5">
                                <img src="../assets/icons/icon_02.png" alt="Default icon">
                            </div>
                            <div class="info-title text-center mb-5">
                                <h3 class="position-relative">{{webData.generalInfo.title}}</h3>
                            </div>
                            <div class="info-text text-center">
                                <p>{{webData.generalInfo.p[0]}}</p>
                                <p>{{webData.generalInfo.p[1]}}</p>
                                <p>{{webData.generalInfo.p[2]}}</p>
                                <p>{{webData.generalInfo.p[3]}}</p>
                                <p>{{webData.generalInfo.p[4]}}</p>
                                <p>{{webData.generalInfo.p[5]}}</p>
                                <p>{{webData.generalInfo.p[6]}}</p>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="info-img text-center mb-5">
                                <img src="../assets/icons/icon_01.png" alt="Default icon">
                            </div>
                            <div class="info-title text-center mb-5">
                                <h3 class="position-relative">{{webData.cancellation.title}}</h3>
                            </div>
                            <div class="info-text text-center">
                                <p>{{webData.cancellation.p[0]}}</p>
                                <p>{{webData.cancellation.p[1]}}</p>
                                <p>{{webData.cancellation.p[2]}}</p>
                                <p>{{webData.cancellation.p[3]}}</p>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="info-img text-center mb-5">
                                <img src="../assets/icons/icon_03.png" alt="Default icon">
                            </div>
                            <div class="info-title text-center mb-5">
                                <h3 class="position-relative">{{webData.terms.title}}</h3>
                            </div>
                            <div class="info-text text-center">
                                <p>{{webData.terms.p[0]}}</p>
                                <p>{{webData.terms.p[1]}}</p>
                                <p>{{webData.terms.p[2]}}</p>
                                <p>{{webData.terms.p[3]}}</p>
                                <p>{{webData.terms.p[4]}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->

        <!--
        <div class="container">
            <div class="pt-5 pb-5">
                <h2 class="position-relative m-title">Detailed description</h2>
                <div class="spacer-mm"></div>
                <p class="text-justify">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a pellentesque lorem. Quisque eleifend nisi ac ligula facilisis, vel iaculis lacus euismod. Praesent mattis justo quis neque pulvinar auctor. Sed pretium dictum lobortis. Sed sit amet mauris cursus, iaculis odio eu, pharetra risus. Nullam consequat pellentesque elit ut maximus. Sed sollicitudin auctor odio. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Fusce fermentum placerat gravida.<br>Curabitur a interdum leo. Proin fermentum libero at justo tempus molestie. Donec tempus ut nunc ut auctor. Sed sit amet erat eu nibh ornare vestibulum. Nam tristique urna justo, vel efficitur massa vehicula ac. Ut lobortis iaculis fringilla. Pellentesque eu lacus vitae arcu imperdiet rutrum. Proin imperdiet orci elit, sed varius ligula consequat sed.<br>Phasellus gravida interdum metus, eu lacinia urna lacinia et. Nunc accumsan finibus odio et egestas. Aenean ultrices vestibulum mi eget tristique. Sed consectetur ante augue, ac ultricies tortor viverra in. Aliquam ligula sem, mollis nec nisl congue, euismod dapibus elit. Curabitur ac porta lectus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Vestibulum at rhoncus metus. Praesent posuere faucibus tempus. Cras vitae condimentum erat. Nullam felis diam, fringilla at mauris et, iaculis luctus purus. Cras mollis urna elit, id tincidunt enim dignissim quis.</p>
            </div>
        </div>
        -->
        <Footer :web-data-global="webData" :key="webData.key"></Footer>
    </div>
</template>

<script>
import Footer from "@/modules/Footer";
import carousel from 'vue-owl-carousel'

import c01 from '../assets/photos/acc_carousel_01.jpg'
import c02 from '../assets/photos/acc_carousel_02.jpg'
import c03 from '../assets/photos/acc_carousel_03.jpg'
import c04 from '../assets/photos/acc_carousel_04.jpg'
import c05 from '../assets/photos/acc_carousel_05.jpg'
import c06 from '../assets/photos/acc_carousel_06.jpg'
import c07 from '../assets/photos/acc_carousel_07.jpg'

export default {
    name: "Services",
    props: {
        webDataGlobal: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            carousel: [
                {id: 1, src: c01, alt: 'Carousel image'},
                {id: 2, src: c02, alt: 'Carousel image'},
                {id: 3, src: c03, alt: 'Carousel image'},
                {id: 4, src: c04, alt: 'Carousel image'},
                {id: 5, src: c05, alt: 'Carousel image'},
                {id: 6, src: c06, alt: 'Carousel image'},
                {id: 7, src: c07, alt: 'Carousel image'},
            ],
            titleLoading: false,
            webData: {}
        }
    },
    created () {
        this.webData = this.webDataGlobal.services;
    },
    mounted () {
        this.settingUpTitle();
    },
    methods: {
        settingUpTitle () {
            this.titleLoading = this.$store.getters.getTitleLoadingState;
            if (!this.titleLoading) {
                setTimeout(() => {
                    this.settingUpTitle();
                }, 400)
            }
        }
    },
    components: {Footer, carousel}
}
</script>

<style scoped>

#services {
    background-color:rgb(232,235,233);
}
#services .jumbo-header {
    background-image: url("../assets/images/katarina8.jpg");
}
.jumbo-header {
    position: relative;
    height: 100vh; 
    display: flex;
    justify-content: center; 
}

.jumbo-header-text {
    font-size: 2em; 
    margin-top: 200px;
    text-align: center; 
    color: white;
}

.custom-spacing {
    margin-right: 8px; 
    display: inline;
}

/* Wedding bride section */

.wedding-first-section, .wedding-second-section {
    padding: 5rem;
    display: flex;
    flex-wrap: wrap;
}

.left-wedding-image {
    flex: 1; 
    max-width: 40%; 
    order: 1;
}
.left-wedding-image img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}

.right-wedding-container {
    flex: 1; 
    max-width: 60%; 
    order: 2; 
    padding: 20px; 
    padding-right: 0px;
}


.right-image {
    margin-top: 20px; 
}
.right-image img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    display: block;
}

.second-section-right {
    max-width: 40%; 
    padding-left: 20px !important;
}

.second-section-left {
    max-width: 60%;
}

.second-right-img img {
    height: 500px !important;
    object-fit: cover;
}
.parallax1 {
    background-image: url('../assets/images/katarina13.jpg');
}

.parallax2 {
    background-image: url('../assets/images/katarina16.jpg');
}

.parallax-container {
    height: 600px; 
    background-size: cover;
    background-position: center;
    background-attachment: fixed; 
    position: relative;
    color: white;
    text-align: center;
    padding-top: 100px; 
}

.video-text-top-right-services {
    position: absolute;
    top: 0px; 
    text-align: center;
    font-size: 2rem;
    width: 100%;
    padding: 65px;
    background-color: #907d728e;
    margin-top: 80px;
    /*border-top: 1px solid white;
    border-bottom: 1px solid white;*/
}
.parallax-content {
    position: absolute;
    top: 0;
    left: 0;
    padding: 40px;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.342);
    margin: 85px;
    border: 2px solid white;
}

.concierge-section {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
    height: 500px;
    display: flex;
    width: 100%;
    /*max-width: 1200px;*/
    margin: 0 auto;
}
.concierge-text-section {
    flex: 70%;
    padding: 20px;
    box-sizing: border-box;
    margin: auto;
    text-align: left;
}

.concierge-text-section-resize {
    padding: 40px !important;
}

.concierge-text-section h3 {
    color: #333;
    margin-top: 0;
    text-align: left;
    font-family: auto;
    font-weight: bold;
    font-family: 'OPTIwtcGoudy';
}
.concierge-text-section p {
    color: #666;
}

.concierge-text {
    font-size: 18px;
}

.k1 {
    background-image: url('../assets/images/katarina14.jpg'); 
    margin-right: 8rem;
}

.k2 {
    background-image: url('../assets/images/katarina15.png'); 
}

.k3 {
    background-image: url('../assets/images/katarina17.jpg');  
    margin-right: 5rem;
    background-size: contain !important;
    background-repeat: no-repeat !important;
}

.k4 {
    background-image: url('../assets/images/katarina18.jpg');  
}

.k5 {
    background-image: url('../assets/images/katarina19.jpg');  
    margin-right: 8rem;
}

.concierge-image-section {
    flex: 30%;
    overflow: hidden;
    background-size: cover;
    background-position: center;
}

.book-now-image-stancija {
        width: 100%;
        height: 700px;
        display: block;
        background-size: cover;
        background-image: url(../assets/images/katarina7.jpg);
        background-position: center;
}
.book-now-content-stancija h1 {
    font-size: 2em;
    margin-bottom: 20px;
    padding: 100px;
}
.book-now-content-stancija {
    position: absolute;
    top: 0px;
    left: 0px;
    color: black;
    font-weight: lighter !important;
}

.contain-scale {
    background-color: #b5c1ca75;
    padding: 20px;
    text-align: center;
    width: 100%;
    min-height: 100%;
}

@media screen and (min-width: 1001px) and (max-width: 1500px) {
    .concierge-center {
        margin-right:75px;
    }
}

@media screen and (min-width: 1000px) {
    .concierge-section {
        margin-left: 5rem;
        margin-right: 5rem;
    }
}

@media screen and (max-width: 768px) {
    .book-now-image-stancija {
        height: 500px;
    }
    .book-now-content-stancija h1 {
        padding: 20px;
    }
    .custom-spacing {
        margin-right: 5px; 
    }
    .yacht-section {
        padding-top: 0px !important;
    }
    .concierge-section {
        margin-bottom: 0px !important;
    }  
    .video-text-top-right-services {
        padding: 45px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
    .many-events-center {
        text-align: center !important;
        font-size: 30px !important;
    }
    .parallax-container {
        background-attachment: local !important;
    }
}
@media screen and (min-width: 768px) {
    .right-wedding-container {
        padding-bottom: 0px;
        padding-left: 100px
    }

    .wedding-first-section {
        
    }
}
@media screen and (max-width: 1000px) {
    .wedding-first-section, .wedding-second-section {
        padding: 10px;
    }
    .left-wedding-image, .right-wedding-container {
        max-width: 100%; 
        order: 0; 
        padding-left: 20px;
        padding-right: 20px;
    }

    .wedding-first-section, .wedding-second-section {
        display: block;
    }

    .right-wedding-container {
        padding-top: 0px;
    }
    .left-wedding-image img {
        margin-top: 50px;
    }
    .concierge-section {
        flex-direction: column-reverse;
        height: auto;
    }
    .not-reverse{
        flex-direction: column;
        height: auto;
    }

    .concierge-text-section {
        margin-left: 0px;
        flex: 100%;
        margin-bottom: 20px;
        margin: 0px;
        text-align: left;
    }

    .concierge-image-section {
        flex: 100%;
        height: 200px; 
        padding: 145px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        margin-right: 30px;
        margin-left: 30px;
        margin: auto !important;
    }
    .image-section-resize{
        padding: 185px !important;
    }
    .k3 {
        background-size: contain !important;
        background-repeat: no-repeat !important;
    }
  
}

@media (max-width: 576px) {
    #services .jumbo-header .ds-image-overlay .matrix-element {
        padding: 150px 0 200px;
    }
}
</style>
